import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

export const ImageGallery = ({ images = [], hotelName = 'Hotel', isOpen, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!isOpen || images.length === 0) return null;

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center" onClick={onClose}>
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-gray-300 z-10"
        data-testid="close-gallery"
      >
        <X className="h-8 w-8" />
      </button>

      <div className="relative w-full h-full flex items-center justify-center px-16" onClick={(e) => e.stopPropagation()}>
        {images.length > 1 && (
          <>
            <button
              onClick={prevImage}
              className="absolute left-4 text-white bg-black/50 hover:bg-black/70 rounded-full p-3"
              data-testid="prev-image"
            >
              <ChevronLeft className="h-8 w-8" />
            </button>
            <button
              onClick={nextImage}
              className="absolute right-4 text-white bg-black/50 hover:bg-black/70 rounded-full p-3"
              data-testid="next-image"
            >
              <ChevronRight className="h-8 w-8" />
            </button>
          </>
        )}

        <div className="max-w-6xl max-h-[90vh] flex flex-col items-center">
          <img
            src={images[currentIndex]}
            alt={`${hotelName} - ${currentIndex + 1}`}
            className="max-w-full max-h-[85vh] object-contain rounded-lg"
          />
          <div className="mt-4 text-white text-center">
            <p className="text-lg font-semibold">{hotelName}</p>
            <p className="text-sm text-gray-300">
              {currentIndex + 1} / {images.length}
            </p>
          </div>
        </div>

        {/* Thumbnail strip */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 overflow-x-auto max-w-3xl pb-2">
          {images.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={`Thumbnail ${idx + 1}`}
              className={`h-16 w-24 object-cover rounded cursor-pointer transition-all ${
                idx === currentIndex ? 'ring-4 ring-white opacity-100' : 'opacity-60 hover:opacity-80'
              }`}
              onClick={() => setCurrentIndex(idx)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
